
import { ScoreThreshold } from '@/types/leadScore';

// Helper functions for lead scoring UI
export const getScoreThresholds = (): ScoreThreshold[] => {
  return [
    { label: 'Cold', minScore: 0, color: 'bg-blue-500' },
    { label: 'Warm', minScore: 40, color: 'bg-yellow-500' },
    { label: 'Hot', minScore: 70, color: 'bg-orange-500' },
    { label: 'Very Hot', minScore: 90, color: 'bg-red-500' }
  ];
};

export const getLeadScoreCategory = (score: number): ScoreThreshold => {
  const thresholds = getScoreThresholds();
  // Find the highest threshold that the score meets or exceeds
  for (let i = thresholds.length - 1; i >= 0; i--) {
    if (score >= thresholds[i].minScore) {
      return thresholds[i];
    }
  }
  return thresholds[0]; // Default to the lowest category
};
